import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Params, RouterStateSnapshot } from "@angular/router";
import { RouterReducerState, RouterStateSerializer } from "@ngrx/router-store";

export interface RouterStateUrl {
    url: string;
    queryParams: Params;
    params: Params;
    children: RouterStateUrl[];
    title?: string;
    backText?: string;
    backAction?: string;
}

export const initialRouteState = {
    state: {
        url: "",
        params: {},
        queryParams: {},
        children: [],
    },
    navigationId: null,
};

export type RouterState = RouterReducerState<RouterStateUrl>;

@Injectable()
export class CustomSerializer implements RouterStateSerializer<RouterStateUrl> {
    serialize(routerState: RouterStateSnapshot): RouterStateUrl {
        const { url } = routerState;
        const { queryParams } = routerState.root;

        let state: ActivatedRouteSnapshot = routerState.root;
        while (state.firstChild && !state.parent) {
            state = state.firstChild;
        }

        const { params, children } = state;

        return {
            url,
            queryParams,
            params,
            children: children.map(child => this.serializeChild(child)),
        };
    }

    serializeChild(routerState: ActivatedRouteSnapshot): RouterStateUrl {
        const { url, queryParams, params, children, data } = routerState;
        return {
            url: url.join("/"),
            queryParams,
            params,
            children: children.map(child => this.serializeChild(child)),
            title: data ? data.title : "",
        };
    }
}
